import * as React from 'react';
import { useSelector } from 'react-redux';

import { MyHomeIcon } from './parts';
import { trackingMyHomeIconClick } from './tracking';
import { Utility } from '../../components/Utility';
import { Utility as UtilityRedesign } from '../../components/Utility/Redesign';
import { selectIsExperimentGroupNameB } from '../../selectors/experiments/myHomeRedesign';
import { IApplicationState } from '../../types/redux';

export const UtilityMyHomeContainer: React.FC = () => {
  const myHomeLink = useSelector<IApplicationState, string>(state => state.servicesLinks.myHome);
  const isMyHomeExit = useSelector<IApplicationState, boolean>(state => state.myHome.isExist);

  // TODO: После завершения эксперимента выпилить ненужное
  const isExperimentGroupB = useSelector(selectIsExperimentGroupNameB);

  if (isExperimentGroupB) {
    return (
      <UtilityRedesign
        title="Мой дом"
        unread={isMyHomeExit}
        onClick={trackingMyHomeIconClick}
        href={myHomeLink}
        icon={MyHomeIcon}
      />
    );
  }

  return (
    <Utility
      title="Мой дом"
      unread={isMyHomeExit}
      onClick={trackingMyHomeIconClick}
      icon={MyHomeIcon}
      href={myHomeLink}
    />
  );
};
